import React from 'react';
import { Maximize2, BedDouble, Bath, Car } from 'lucide-react';

interface PropertyKeyMetricsStripProps {
  area: string;
  rooms: number | string;
  baths: number | string;
  parking: number | string;
}

export const PropertyKeyMetricsStrip: React.FC<PropertyKeyMetricsStripProps> = ({
  area,
  rooms,
  baths,
  parking,
}) => {
  const metrics = [
    { label: 'Área Total', value: area, icon: Maximize2 },
    { label: 'Habitaciones', value: `${rooms} hab.`, icon: BedDouble },
    { label: 'Baños', value: `${baths} baños`, icon: Bath },
    { label: 'Parqueaderos', value: `${parking} garajes`, icon: Car },
  ];

  return (
    <div className="w-full grid grid-cols-4 gap-2 mb-3">
      {metrics.map((item, index) => {
        const IconComponent = item.icon;
        return (
          <div
            key={index}
            className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-slate-50/90 border border-slate-200/80 shadow-2xs min-w-0"
          >
            <div className="w-6 h-6 rounded-lg bg-white border border-slate-200/60 flex items-center justify-center text-[#0a2540] flex-shrink-0 shadow-2xs">
              <IconComponent className="w-3.5 h-3.5" />
            </div>
            <div className="min-w-0 py-0.5">
              <div className="text-[9.5px] font-bold text-slate-400 uppercase tracking-normal leading-normal truncate">
                {item.label}
              </div>
              <div className="text-[12px] font-bold text-[#0a2540] tracking-normal leading-normal whitespace-nowrap truncate">
                {item.value}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
